export const TIPLINK_BUILD_ENV = {
    PRODUCTION: "production",
    STAGING: "staging",
    DEVELOPMENT: "development",
    ADAPTER: "adapter",
    LOCAL: "local",
};
//# sourceMappingURL=interfaces.js.map